import React from 'react';
import PropTypes from 'prop-types';

import { H1, H2, H3, H4, Paragraph } from 'components/core/Typography';
import { Image } from 'components/core/Image';
import { MarkdownContent } from 'components/core/MarkdownContent';
import { Link } from 'components/core/Link';

import './PSPMarkdownContent.scss';

const markdownContentMap = (additionalProps) => ({
	h1: (props) => <H1 size="large" weight="ultraBold" {...additionalProps?.heading} {...props} />,
	h2: (props) => <H2 size="large" weight="ultraBold" {...additionalProps?.heading} {...props} />,
	h3: (props) => <H3 size="medium" weight="ultraBold" {...additionalProps?.heading} {...props} />,
	h4: (props) => <H4 size="tall" {...additionalProps?.heading} {...props} />,
	p: (props) => <Paragraph size="standard" weight="standard" color="gray" {...additionalProps?.paragraph} {...props} />,
	a: (props) => <Link color="gray" inheritFont {...additionalProps?.anchor} {...props} />,
	img: (props) => <Image 	{...props} {...additionalProps?.img} />,
	ul: (props) => <ul className="psp-markdown-ul-padding" {...additionalProps?.ul} {...props} />,
	ol: (props) => <ol className="psp-markdown-ol" {...additionalProps?.ol} {...props} />
});

// This is only a text component, use it for adding text into any PSP module
// It needs to be imported in a PSP module
export default function PSPMarkdownContent({ content, additionalProps }) {
	const markdownComponents = markdownContentMap(additionalProps)
	return (
		<MarkdownContent
			components={markdownComponents}
			content={content}
		/>
	);
}

PSPMarkdownContent.propTypes = {
	content: PropTypes.string.isRequired,
	additionalProps: PropTypes.object
};
